import { render, staticRenderFns } from "./SettingsStageThirdPlaceMatch.vue?vue&type=template&id=0bc7e075&"
import script from "./SettingsStageThirdPlaceMatch.vue?vue&type=script&lang=js&"
export * from "./SettingsStageThirdPlaceMatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports